import { cartActionTypes } from './cart-action-types';
import { authorizedRequest } from '../../common/request';
import {applicationHistory} from "../../common/application-history";



export const requestCartData = (dispatch) => {
	authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/cart?createRpcChildIfNeeded=true&format=deep`)
		.then(element => {
            if(element) {
                if (typeof (element.lineItems) == "undefined" || element.lineItems == null) {
                    element.lineItems = [];
                }
                dispatch(cartDataReceived(element))
                if (element.isDigitizingOrder && element.orderType !== "RPC" && window.localStorage.getItem('initialLoginRefresh') === "true") {
                    if(element.includesEnhancementEligibleAssets === true) {
                        console.log("Redirecting to digitization choice")
                        applicationHistory.push("/my/cart/digitization")
                    }else{
                        console.log("Redirecting to checkout")
                        applicationHistory.push("/my/cart")
                    }
                }
            }else{
                dispatch(cartDataReceived({}))
            }
            window.localStorage.setItem('initialLoginRefresh','false');
        })
		.catch(error => dispatch(cartDataFailed(error)));

	return {
		type: cartActionTypes.CART_REQUESTED
	};
};
export const fetchOrder = (orderId, dispatch) => {
    authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/orders/${orderId}?format=deep`,null, "GET")
        .then(element => dispatch(cartDataReceived(element)))
        .catch(error => dispatch(cartDataFailed(error)));

    return {
        type: cartActionTypes.CART_REQUESTED
    };
}
export const deleteCartItem = (itemId, dispatch) => {
    authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/cart/item/${itemId}?format=deep`,null, "DELETE")
        .then(element => dispatch(cartDataReceived(element)))
        .catch(error => dispatch(cartDataFailed(error)));

    return {
        type: cartActionTypes.CART_DELETE_ITEM,
		value: {itemId: itemId}
    };
}
export const updateLineItemQty = (itemId, qty, dispatch) => {
    authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/cart/item/${itemId}?format=deep`,{unitQty: qty}, "PUT")
        .then(element => dispatch(cartDataReceived(element)))
        .catch(error => dispatch(cartDataFailed(error)));

}
export const addProductToCart = (prodCode, qty, dispatch) => {

    authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/cart/add/product/${prodCode}?qty=${qty}&format=deep`,null, "POST")
        .then(element => dispatch(cartDataReceived(element)))
        .catch(error => dispatch(cartDataFailed(error)));

    return {
        type: cartActionTypes.CART_ADD_PRODUCT,
        value: {prodCode: prodCode, qty: qty}
    };
}
export const addRushProcessing = (dispatch) => {
    authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/cart/add/rush?format=deep`,null, "POST")
        .then(element => dispatch(cartDataReceived(element)))
        .catch(error => dispatch(cartDataFailed(error)));

    return {
        type: cartActionTypes.CART_ADD_PRODUCT,
        value: {prodCode: '071', qty: 1}
    };
}
export const addDiskDriveDescriptorToCart = (diskDriveDescriptorId, dispatch) => {
    authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/cart/add/ddd/${diskDriveDescriptorId}?format=deep`,null, "POST")
        .then(element => dispatch(cartDataReceived(element)))
        .catch(error => dispatch(cartDataFailed(error)));

    return {
        type: cartActionTypes.CART_ADD_DDD,
        value: {diskDriveDescriptorId: diskDriveDescriptorId}
    };
}
export const updateLocalQty = (itemId, qty, dispatch) => {

    return {
        type: cartActionTypes.CART_QTY_UPDATE,
        value: {itemId: itemId, qty: qty}
    };
}
export const toggleOrderProcessType = (dispatch) => {
    authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/cart/toggle/d2d?format=deep`,null, "POST")
        .then(element => dispatch(cartDataReceived(element)))
        .catch(error => dispatch(cartDataFailed(error)));
    return {
        type: cartActionTypes.CART_TOGGLE_PROCESS_TYPE
    }
}
export const setAIEnhance = (dispatch, isEnhance) => {
    authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/cart/toggle/enhancement?enhance=${isEnhance}&format=deep`,null, "POST")
        .then(element => dispatch(cartDataReceived(element)))
        .catch(error => dispatch(cartDataFailed(error)));
    return {
        type: cartActionTypes.CART_TOGGLE_AI_TYPE,
        isAI: isEnhance
    }
}
export const submitCartForCheckout = (cart, dispatch) => {
    authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/cart/process?format=deep`,cart, "POST")
        .then(element => {
            if(element.errorMessage != null ) {
                dispatch(cartCheckoutFailed(element))
            }else if(typeof(element.ka) !== "undefined" && element.ka == "boom"){
                dispatch(cartCheckoutFailed({errorMessage: "The card was declined"}))
            }else {
                dispatch(cartCheckoutSuccess(element));
            }

        })
        .catch(error => {
            error.json().then(errorBlock=>dispatch(cartCheckoutFailed(errorBlock)));
        });
}
export const approveRpcOrder = ( dispatch) => {
    authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/rpc/approve?format=deep`,null, "PUT")
        .then(element => {
            if(element.errorMessage != null){
                dispatch(cartCheckoutFailed(element))
            }else {
                dispatch(cartCheckoutSuccess(element));
            }

        })
        .catch(error => {
            if(error.json) {
                error.json().then(errorBlock => dispatch(cartCheckoutFailed(errorBlock)));
            }else{
                dispatch(cartCheckoutFailed({errorMessage: `Checkout failed: ${error.message}`}))
            }
        });
}
export const applyPromoCode = (dispatch, promoCode,callback) => {
    authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/cart/apply/promo/${promoCode}?format=deep`,null, "POST",false,false)
        .then(element => {
            if(Array.isArray(element)){
                let errorMsg = "Invalid Promocode"
                if(Array.isArray(element)){
                    errorMsg = element[0].name;
                }
                callback({response:"FAILED",errorMessage: errorMsg})
                dispatch(cartDataFailed({errorMessage: errorMsg}))
            }else {
                if(callback != null){
                    callback({response:"OK",cart:element})
                }
                dispatch(cartDataReceived(element));
            }
        })
        .catch(error => {
            let errorMsg = "Invalid Promocode"
            if(Array.isArray(error)){
                errorMsg = error[0].name;
            }
            if(callback != null){
                callback({response:"FAILED",errorMessage: errorMsg})
            }
            dispatch(cartDataFailed({errorMessage: errorMsg}))
        });
}
export const removePromoCode = (dispatch,callback) => {
    authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/cart/remove/promo?format=deep`,null, "DELETE",false,false)
        .then(element => {
            if(Array.isArray(element)){
                let errorMsg = "Invalid Promocode"
                if(Array.isArray(element)){
                    errorMsg = element[0].name;
                }
                callback({response:"FAILED",errorMessage: errorMsg})
                dispatch(cartDataFailed({errorMessage: errorMsg}))
            }else {
                if(callback != null){
                    callback({response:"OK",cart:element})
                }
                dispatch(cartDataReceived(element));
            }
        })
        .catch(error => {
            let errorMsg = "Invalid Promocode"
            if(Array.isArray(error)){
                errorMsg = error[0].name;
            }
            if(callback != null){
                callback({response:"FAILED",errorMessage: errorMsg})
            }
            dispatch(cartDataFailed({errorMessage: errorMsg}))
        });
}
export const applyGiftCard = (dispatch, giftCard, callback ) => {
    authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/cart/apply/giftcard/${giftCard}?format=deep`,null, "POST")
        .then(element => {
            if(element.errorMessage){
                if(callback != null){
                    callback({status:"FAILED",errorMessage:element.errorMessage})
                }
                dispatch(cartDataFailed(element))
            }else {
                if(callback != null){
                    callback({status:"OK"})
                }
                dispatch(cartDataReceived(element));
            }
        })
        .catch(error => {
            if(callback != null){
                callback({status:"FAILED",errorMessage:error})
            }
            dispatch(cartDataFailed(error))
        });
}
const cartDataReceived = (element) => {
	return {
		type: cartActionTypes.CART_RECEIVED,
        element: element
	};
};

const cartDataFailed = error => {
	return {
		type: cartActionTypes.CART_FAILED,
		error: error
	};
};
const cartCheckoutSuccess = element => {
    return {
        type: cartActionTypes.CART_CHECKOUT_SUCCESS,
        element: element
    }
}
const cartCheckoutFailed = error => {
    return {
        type: cartActionTypes.CART_CHECKOUT_FAILED,
        error: error
    }
}

const cartUpdateShipping = (cart) => {
    return {
        type: cartActionTypes.CART_UPDATE_SHIPPING,
        element: cart
    }
}
export const aiEnhanceSkip = () => {
    return {
            type: cartActionTypes.CART_PROCESS_AI_CHOICE_MADE
        }
}
export const updateCheckoutItems = (fieldData, dispatch) => {
    if(fieldData.field === "preferredShippingMethod"){
        //This is because the webapi expects ground/2day/1day/pickup while the DB stores "Ground","Second Day","Next Day" and "Pickup"
        let shippingMethodTransformed = fieldData.value === "Ground" ? "ground": fieldData.value === "Second Day"?"2day":fieldData.value === "Next Day"?"1day":"pickup";
        //Special call to recalculate shipping total
        authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/cart/shipping/${shippingMethodTransformed}?format=deep`,null, "PUT")
            .then(element => dispatch(cartUpdateShipping(element)))
            .catch(error => dispatch(cartDataFailed(error)));
    }else{
        //TODO: most checkout fields only get updated in the DB after processCartOrder is called
        //There may be some we need to push to the DB.  The problem is checkout fields are LOCAL redux state, but if something changes the card on the serverside,
        //it the cart coming back from webapi will override the local state.

    }
    return {
        type: cartActionTypes.CART_UPDATE_CHECKOUT,
        element: fieldData
    }
}
export const updateShippingAddress = (shipping, dispatch) => {
    authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/cart/shipping?format=deep`,shipping, "PUT")
        .then(element => {
            if(!element.errorMessage) {
                dispatch(cartUpdateShipping(element))
            }
        })
        .catch(error => dispatch(cartDataFailed(error)));
    return {
        type: cartActionTypes.CART_UPDATE_SHIPPING_REQUESTED,
        element: shipping
    }
}
export const checkoutAcknowledged = () => {
    return {type: cartActionTypes.CART_CHECKOUT_ACKNOWLEDGED}
}
export const updateDueDate = (dueDate, applicationHistory, dispatch) => {
    authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/cart/dueDate?format=deep`,{dueDate: dueDate}, "PUT")
        .then(element => {
            dispatch(cartDataReceived(element))
            applicationHistory.push("/my/cart/checkout");
        })
        .catch(error => dispatch(cartDataFailed(error)));
    return {
        type: cartActionTypes.CART_DUE_DATE_REQUESTED,
        element: dueDate
    }
}
export const processChoiceMade = () => {
    return {
        type: cartActionTypes.CART_PROCESS_TYPE_CHOICE_MADE
    }
}


// WEBPACK FOOTER //
// ./src/cart/actions/cart-actions.js